<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>Keramicke Kondenzatory a.s.</h3>
          <p>Premier manufacturer of high-quality ceramic capacitors since 1990 in Hradec Kralove, Czech Republic.</p>
          <div class="contact-info">
            <p>📧 sales@keramicke-kondenzatory.cz</p>
            <p>📞 +420 495 532 111</p>
          </div>
        </div>
        
        <div class="footer-section">
          <h4>Product Categories</h4>
          <ul>
            <li><router-link to="/products">MLCC - Multilayer</router-link></li>
            <li><router-link to="/products">High Voltage</router-link></li>
            <li><router-link to="/products">RF/Microwave</router-link></li>
            <li><router-link to="/products">Safety Certified</router-link></li>
            <li><router-link to="/products">Automotive Grade</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>Company</h4>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/products">Products</router-link></li>
            <li><router-link to="/team">Team</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>Connect</h4>
          <div class="social-links">
            <a href="#" aria-label="Instagram">IG</a>
            <a href="#" aria-label="LinkedIn">LI</a>
            <a href="#" aria-label="Facebook">FB</a>
            <a href="#" aria-label="Twitter">TW</a>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; 2025 Keramicke Kondenzatory a.s. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Footer navigation component for Keramicke Kondenzatory a.s.
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 3rem 0 1rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: 1rem;
  font-weight: 600;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.footer-section p {
  margin-bottom: 1rem;
  opacity: 0.9;
  line-height: 1.6;
}

.contact-info p {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section li {
  margin-bottom: 0.5rem;
}

.footer-section a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.footer-section a:hover {
  opacity: 1;
  text-decoration: underline;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.social-links a:hover {
  background: rgba(255, 255, 255, 0.3);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 1rem;
  text-align: center;
  opacity: 0.8;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 2rem 0 1rem;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .social-links {
    justify-content: center;
  }
}
</style>